import script from "./ExportRecordList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportRecordList.vue?vue&type=script&setup=true&lang=js"

import "./ExportRecordList.vue?vue&type=style&index=0&id=296629d7&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296629d7"]])

export default __exports__